import { render, staticRenderFns } from "./detailImportAverageWage.vue?vue&type=template&id=f239f934&scoped=true&"
import script from "./detailImportAverageWage.vue?vue&type=script&lang=js&"
export * from "./detailImportAverageWage.vue?vue&type=script&lang=js&"
import style0 from "./detailImportAverageWage.vue?vue&type=style&index=0&id=f239f934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f239f934",
  null
  
)

export default component.exports